/**
 * Modern Sidebar Filter Functionality
 */
(function() {
  // Wait for the page to be fully loaded
  window.addEventListener('load', function() {
    console.log('Window loaded, initializing modern sidebar filter');
    initModernSidebarFilter();
  });

  function initModernSidebarFilter() {
    console.log('Initializing modern sidebar filter');

    // Initialize price slider
    initPriceSlider();

    // Initialize category toggles
    initCategoryToggles();

    // Initialize filter checkboxes
    initFilterCheckboxes();

    // Initialize clear filters
    initClearFilters();

    // Initialize form submission on Enter key
    initFormSubmission();
  }

  function initPriceSlider() {
    console.log('Initializing price slider');

    const priceSlider = document.querySelector('.modern-sidebar-filter__price-slider');
    if (!priceSlider) {
      console.error('Price slider element not found');
      return;
    }

    const minPriceDisplay = document.getElementById('filter-price-min');
    const maxPriceDisplay = document.getElementById('filter-price-max');
    const minPriceInput = document.getElementById('filter-price-min-input');
    const maxPriceInput = document.getElementById('filter-price-max-input');
    const applyButton = document.querySelector('.modern-sidebar-filter__price-apply');

    if (!minPriceDisplay || !maxPriceDisplay || !minPriceInput || !maxPriceInput || !applyButton) {
      console.error('Price slider related elements not found');
      return;
    }

    const minPrice = parseInt(minPriceInput.value) || 6000;
    const maxPrice = parseInt(maxPriceInput.value) || 95000;

    console.log('Setting up price slider with values:', minPrice, maxPrice);

    // Create a simple slider bar (no jQuery UI needed)
    const sliderBar = document.createElement('div');
    sliderBar.className = 'slider-bar';
    sliderBar.style.height = '6px';
    sliderBar.style.backgroundColor = '#ccc';
    sliderBar.style.width = '100%';

    // Clear the slider and append the bar
    priceSlider.innerHTML = '';
    priceSlider.appendChild(sliderBar);

    // Set initial display values
    minPriceDisplay.textContent = '$' + minPrice.toLocaleString();
    maxPriceDisplay.textContent = '$' + maxPrice.toLocaleString();

    // Add event listener to the apply button
    applyButton.addEventListener('click', function(e) {
      e.preventDefault();

      const form = priceSlider.closest('form');
      if (form) {
        // Add the filter tag to the active filters section
        const minValue = minPriceInput.value;
        const maxValue = maxPriceInput.value;
        addActiveFilterTag('Price Range', '$' + parseInt(minValue).toLocaleString() + ' - $' + parseInt(maxValue).toLocaleString());

        // Submit the form
        form.submit();
      }
    });
  }

  function initCategoryToggles() {
    const categoryHeaders = document.querySelectorAll('.modern-sidebar-filter__category-header');

    categoryHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const category = this.closest('.modern-sidebar-filter__category');
        category.classList.toggle('collapsed');
      });
    });
  }

  function initFilterCheckboxes() {
    const filterCheckboxes = document.querySelectorAll('.modern-sidebar-filter__checkbox input');

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        // Get the filter label and value
        const label = this.closest('.modern-sidebar-filter__option').querySelector('.modern-sidebar-filter__option-label').textContent;

        // Add the filter tag to the active filters section if checked
        if (this.checked) {
          addActiveFilterTag(label, '');
        }

        // Submit the form to apply the filter
        const form = this.closest('form');
        if (form) {
          form.submit();
        }
      });
    });
  }

  function addActiveFilterTag(label, value) {
    const activeFiltersContainer = document.querySelector('.modern-sidebar-filter__active-filters');
    if (!activeFiltersContainer) return;

    // Create a new active filter tag
    const activeTag = document.createElement('div');
    activeTag.className = 'modern-sidebar-filter__active-tag';
    activeTag.textContent = value ? `${label}: ${value}` : label;

    // Create the remove button
    const removeButton = document.createElement('a');
    removeButton.className = 'modern-sidebar-filter__active-tag-icon';
    removeButton.textContent = '×';
    removeButton.href = '#';
    removeButton.addEventListener('click', function(e) {
      e.preventDefault();
      activeTag.remove();

      // Find and uncheck the corresponding checkbox
      const checkboxes = document.querySelectorAll('.modern-sidebar-filter__checkbox input');
      checkboxes.forEach(checkbox => {
        const checkboxLabel = checkbox.closest('.modern-sidebar-filter__option').querySelector('.modern-sidebar-filter__option-label').textContent;
        if (checkboxLabel === label) {
          checkbox.checked = false;
        }
      });

      // Submit the form to apply the filter removal
      const form = document.getElementById('ModernCollectionFiltersForm');
      if (form) {
        form.submit();
      }
    });

    // Add the remove button to the tag
    activeTag.appendChild(removeButton);

    // Add the tag to the container
    activeFiltersContainer.appendChild(activeTag);

    // Update the match count
    updateMatchCount();
  }

  function updateMatchCount() {
    const matchCountElement = document.querySelector('.modern-sidebar-filter__title');
    if (!matchCountElement) return;

    const activeFilters = document.querySelectorAll('.modern-sidebar-filter__active-tag');
    matchCountElement.textContent = activeFilters.length + ' matches';
  }

  function initClearFilters() {
    const clearFiltersButton = document.querySelector('.modern-sidebar-filter__clear');
    if (!clearFiltersButton) return;

    clearFiltersButton.addEventListener('click', function(e) {
      e.preventDefault();

      // Clear all checkboxes
      const checkboxes = document.querySelectorAll('.modern-sidebar-filter__checkbox input');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });

      // Reset price values
      const minPriceDisplay = document.getElementById('filter-price-min');
      const maxPriceDisplay = document.getElementById('filter-price-max');
      const minPriceInput = document.getElementById('filter-price-min-input');
      const maxPriceInput = document.getElementById('filter-price-max-input');

      if (minPriceDisplay && maxPriceDisplay && minPriceInput && maxPriceInput) {
        minPriceDisplay.textContent = '$6,000';
        maxPriceDisplay.textContent = '$95,000';
        minPriceInput.value = '6000';
        maxPriceInput.value = '95000';
      }

      // Clear all active filter tags
      const activeFiltersContainer = document.querySelector('.modern-sidebar-filter__active-filters');
      if (activeFiltersContainer) {
        activeFiltersContainer.innerHTML = '';
      }

      // Update match count
      const matchCountElement = document.querySelector('.modern-sidebar-filter__title');
      if (matchCountElement) {
        matchCountElement.textContent = '0 matches';
      }

      // Submit the form or redirect to the collection URL without filters
      window.location.href = this.getAttribute('href') || window.location.pathname;
    });
  }

  function initFormSubmission() {
    const form = document.getElementById('ModernCollectionFiltersForm');
    if (!form) return;

    // Add event listener for Enter key on text inputs
    const textInputs = form.querySelectorAll('input[type="text"], input[type="number"]');
    textInputs.forEach(input => {
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();

          // Get the input label and value
          let label = '';
          let value = this.value;

          // Try to find a label for this input
          const labelElement = this.closest('.modern-sidebar-filter__category').querySelector('.modern-sidebar-filter__category-title');
          if (labelElement) {
            label = labelElement.textContent;
          }

          // Add the filter tag to the active filters section
          if (label && value) {
            addActiveFilterTag(label, value);
          }

          // Submit the form
          form.submit();
        }
      });
    });
  }
})();
